import { Action } from 'redux';
import AbaTypeEnum from '~Api/WarehouseLoanTransactionAba/AbaTypeEnum';
import WarehouseLoanTransactionAbasActionsEnum from './ActionsEnum';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import IWarehouseLoanTransactionAba from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAba';
import IWarehouseLoanTransactionAbaHistory from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAbaHistory';
import AbaTypeGroupEnum from './AbaTypeGroupEnum';

export interface IAbasAddAction extends Action {
    abaType: AbaTypeEnum;
    transactionUuids: string[];
}

export function abasAddAction(abaType: AbaTypeEnum, transactionUuids: string[]): IAbasAddAction {
    return {
        abaType,
        transactionUuids: transactionUuids,
        type: WarehouseLoanTransactionAbasActionsEnum.AbasAdd,
    };
}

export interface IAbasListAction extends Action {
    abaTypeGroup: AbaTypeGroupEnum;
}

export function abasListAction(abaTypeGroup: AbaTypeGroupEnum): IAbasListAction {
    return {
        abaTypeGroup,
        type: WarehouseLoanTransactionAbasActionsEnum.AbasList,
    };
}

export interface IAbasSetAction extends Action {
    abas: IWarehouseLoanTransactionAba[];
    abaTypeGroup: AbaTypeGroupEnum;
}

export function abasSetAction(abaTypeGroup: AbaTypeGroupEnum, abas: IWarehouseLoanTransactionAba[]): IAbasSetAction {
    return {
        abaTypeGroup,
        abas,
        type: WarehouseLoanTransactionAbasActionsEnum.AbasSet,
    };
}

export interface IAbaGetAction extends Action {
    uuid: string;
}

export function abaGetAction(uuid: string): IAbaGetAction {
    return {
        type: WarehouseLoanTransactionAbasActionsEnum.AbaGet,
        uuid,
    };
}

export interface IAbaHistoriesListAction extends Action {
    uuid: string;
}

export function abaHistoriesListAction(uuid: string): IAbaHistoriesListAction {
    return {
        type: WarehouseLoanTransactionAbasActionsEnum.AbaHistoriesList,
        uuid,
    };
}

export interface IAbaHistoriesSetAction extends Action {
    histories: IWarehouseLoanTransactionAbaHistory[];
    uuid: string;
}

export function abaHistoriesSetAction(uuid: string, histories: IWarehouseLoanTransactionAbaHistory[]): IAbaHistoriesSetAction {
    return {
        histories,
        type: WarehouseLoanTransactionAbasActionsEnum.AbaHistoriesSet,
        uuid,
    };
}

export interface IAbaSetAction extends Action {
    aba: IWarehouseLoanTransactionAba;
}

export function abaSetAction(aba: IWarehouseLoanTransactionAba): IAbaSetAction {
    return {
        aba,
        type: WarehouseLoanTransactionAbasActionsEnum.AbaSet,
    };
}

export interface IAbaTransactionsListAction extends Action {
    uuid: string;
}

export function abaTransactionsListAction(uuid: string): IAbaTransactionsListAction {
    return {
        type: WarehouseLoanTransactionAbasActionsEnum.AbaTransactionsList,
        uuid,
    };
}

export interface IAbaTransactionsSetAction extends Action {
    transactions: IWarehouseLoanTransaction[];
    uuid: string;
}

export function abaTransactionsSetAction(uuid: string, transactions: IWarehouseLoanTransaction[]): IAbaTransactionsSetAction {
    return {
        transactions,
        type: WarehouseLoanTransactionAbasActionsEnum.AbaTransactionsSet,
        uuid,
    };
}

export interface IUnallocatedTransactionsListAction extends Action {
    abaType: AbaTypeEnum;
}

export function unallocatedTransactionsListAction(abaType: AbaTypeEnum): IUnallocatedTransactionsListAction {
    return {
        abaType,
        type: WarehouseLoanTransactionAbasActionsEnum.UnallocatedTransactionsList,
    };
}

export interface IUnallocatedTransactionsSetAction extends Action {
    abaType: AbaTypeEnum;
    transactions: IWarehouseLoanTransaction[];
}

export function unallocatedTransactionsSetAction(abaType: AbaTypeEnum, transactions: IWarehouseLoanTransaction[]): IUnallocatedTransactionsSetAction {
    return {
        abaType,
        transactions,
        type: WarehouseLoanTransactionAbasActionsEnum.UnallocatedTransactionsSet,
    };
}
